var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentType,_vm._b({tag:"component",class:_vm.classList,attrs:{"disabled":_vm.buttonDisabled},on:{"click":_vm.click}},'component',_vm.dynamicAttrs,false),[_vm._v("\n  "+_vm._s(_vm.buttonOptions.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }